/**
 * Custom Bell Icon
 * Matches Figma design - notification bell
 */

interface BellIconProps {
  size?: number;
  className?: string;
}

export function BellIcon({ size = 24, className }: BellIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Bell clapper */}
      <path d="M13.6907 28C13.9247 28.4054 14.2614 28.742 14.6667 28.976C15.0721 29.21 15.5319 29.3332 16 29.3332C16.4681 29.3332 16.9279 29.21 17.3333 28.976C17.7387 28.742 18.0753 28.4054 18.3093 28" />
      {/* Bell body */}
      <path d="M4.34934 20.4346C4.17516 20.6255 4.06021 20.8629 4.01848 21.118C3.97674 21.373 4.01003 21.6347 4.11428 21.8712C4.21853 22.1076 4.38925 22.3087 4.60568 22.4499C4.8221 22.5912 5.07491 22.6664 5.33334 22.6666H26.6667C26.9251 22.6667 27.1779 22.5917 27.3945 22.4508C27.6111 22.3098 27.782 22.109 27.8865 21.8726C27.991 21.6363 28.0247 21.3747 27.9833 21.1197C27.9419 20.8646 27.8272 20.6271 27.6533 20.436C25.88 18.608 24 16.6653 24 10.6666C24 8.54489 23.1571 6.51006 21.6569 5.00977C20.1566 3.50948 18.1217 2.66663 16 2.66663C13.8783 2.66663 11.8434 3.50948 10.3431 5.00977C8.84286 6.51006 8 8.54489 8 10.6666C8 16.6653 6.11867 18.608 4.34934 20.4346Z" />
    </svg>
  );
}

export default BellIcon;
